import { createAction } from "@reduxjs/toolkit";
import { IOperation } from "interfaces/operations/Operations";
import { ISwRepoSummaryItem, ManageSwReportsTabs } from "./ManageSwReportsTypes";

export const setSearchText = createAction<string>("manageSwReports/setSearchText");
export const setLoadOperation = createAction<{ loadOperation: IOperation }>("manageSwReports/setLoadOperation");
export const setSwRepoListData = createAction<ISwRepoSummaryItem[]>("manageSwReports/setSwRepoListData");
export const downloadSwRepoPdf = createAction<{ uid: string, version: string, sourceSystem: string, isArchived:boolean }>("manageSwReports/downloadSwRepoPdf");
export const setCurrentTab = createAction<ManageSwReportsTabs>("manageSwReports/setCurrentTab");